class Flussonic {
  constructor() {
    this.timeout = null
  }
  async convert(url) {
    if (this.timeout) this.timeout = clearTimeout(this.timeout)
    if (!url.initial) return false

    const ext = url.initial.split(".").pop()
    const ipPattern = /(^127\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^192\.168\.)/
    if (["mp4", "mkv", "avi", "ts", "m3u8"].includes(ext) && url.origin !== __.platform.baseUrl && !ipPattern.test(url.host)) return false

    if (url.initial.includes("flussonic")) return this._convertForFlussonic(url)
    else if (["mp4", "ts", "mp3", "mkv"].indexOf(ext) >= 0) return this._convertForVod(url)
    else return this._convertForStreams(url)
  }
  async _convertForStreams(url) {
    const name = url.initial.slugify()
    const expire = new Date().getTime() / 1000 + 3600
    const { tokenLive } = await __.api.get.cdn({ driver: "flussonic", expire: Math.round(expire), name })

    this.timeout = setTimeout(() => __.media.play(url.initial), 3300 * 1000)
    return `${__.platform.baseUrl}/flussonic/${name}/index.m3u8?token=${tokenLive}`
  }
  async _convertForVod(url) {
    return `${__.platform.baseUrl}/flussonic/vod${url.path}/index.m3u8`
  }
  async _convertForFlussonic(url) {
    if (url.path.includes("flussonic/vod")) return url.initial

    const name = url.path.split("/")
    const duration = name[3]
      .split(".")
      .shift()
      .split("-")
      .pop()
    const expire = new Date().getTime() / 1000 + parseInt(duration)

    const { tokenLive } = await __.api.get.cdn({ driver: "flussonic", expire: Math.round(expire), name: name[2] })
    return `${url.initial}?token=${tokenLive}`
  }
}

export default new Flussonic()
